import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGet = gql`
  query getMultitenantAliases {
    getMultitenantAliases {
      data {
        id: aliasName
        description: friendlyName
      }
      recordCount
    }
  }
`;

const FieldSelectMultitenantAliases = ({
  label = 'Επιλέξτε Χρήση',
  name = 'alias',
  defaultValues = {},
  ...rest
}: any) => {
  function useGet() {
    const options: any = { fetchPolicy: 'no-cache' };
    return useLazyQuery(gqlGet, options);
  }

  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      sbLabel={(defaultValues as any)?.getMultitenantAliases?.name ?? undefined}
      hook={useGet}
    />
  );
};

export { FieldSelectMultitenantAliases };
